import axios from "axios";

import { setupCache } from "axios-cache-adapter";

const cache = setupCache({
  maxAge: 15 * 60 * 1000,
  exclude: { query: false },
});

const api = axios.create({
  adapter: cache.adapter,
});

export function voip_login(call_id) {
  const params = {
    call_id,
  };

  return api
    .get("https://ru-tel.com/c/callframe/v2/auth.php", { params })
    .then((response) => {
      return response.data;
    });
}
